import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import JsonLd from '../components/JsonLd';

const SobrePage = () => {
  return (
    <>
      <Helmet>
        <html lang="pt-BR" />
        <title>Sobre a Calculadora de Horas | Ferramentas CLT Grátis</title>
        <meta name="description" content="Conheça a Calculadora de Horas, ferramenta online grátis que calcula horas trabalhadas, extras, banco de horas e adicional noturno conforme a CLT." />
        <meta name="robots" content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large" />
        <link rel="canonical" href="https://calculadoradehoras.net.br/sobre" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="Sobre a Calculadora de Horas | Ferramentas CLT Grátis" />
        <meta property="og:description" content="Conheça a Calculadora de Horas, ferramenta online grátis que calcula horas trabalhadas, extras, banco de horas e adicional noturno conforme a CLT." />
        <meta property="og:url" content="https://calculadoradehoras.net.br/sobre" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:site_name" content="Calculadora de Horas" />
        <meta property="og:image" content="https://calculadoradehoras.net.br/og-image.png" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Sobre a Calculadora de Horas | Ferramentas CLT Grátis" />
        <meta name="twitter:description" content="Conheça a Calculadora de Horas, ferramenta online grátis que calcula horas trabalhadas, extras, banco de horas e adicional noturno conforme a CLT." />

        <link rel="alternate" hrefLang="pt-BR" href="https://calculadoradehoras.net.br/sobre" />
        <link rel="alternate" hrefLang="x-default" href="https://calculadoradehoras.net.br/sobre" />
      </Helmet>
      <JsonLd data={{
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        "itemListElement": [
          {"@type":"ListItem","position":1,"name":"Início","item":"https://calculadoradehoras.net.br/"},
          {"@type":"ListItem","position":2,"name":"Sobre","item":"https://calculadoradehoras.net.br/sobre"}
        ]
      }} />

      <Navigation />
      
      <main className="max-w-4xl mx-auto px-4 py-8">
        <nav className="text-sm text-body-text mb-4" aria-label="Breadcrumb">
          <a href="/" className="hover:text-blue-primary">Início</a>
          <span className="mx-2">›</span>
          <span>Sobre</span>
        </nav>
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-dark-text mb-4">
            Sobre a Calculadora de Horas
          </h1>
        </div>

        <article className="prose prose-lg max-w-none bg-white rounded-2xl shadow-lg p-8">
          <p className="text-body-text text-lg leading-relaxed mb-6">
            O <strong>Calculadora de Horas</strong> é uma ferramenta online gratuita criada para ajudar trabalhadores brasileiros a calcular suas horas de trabalho com precisão e facilidade.
          </p>

          <p className="text-body-text text-lg leading-relaxed mb-6">
            Nosso objetivo é simplificar o cálculo de horas trabalhadas, horas extras, banco de horas e adicional noturno, sempre seguindo as regras da CLT (Consolidação das Leis do Trabalho).
          </p>

          <p className="text-body-text text-lg leading-relaxed mb-6">
            Acreditamos que todo trabalhador tem o direito de entender e conferir seus cálculos de horas. Por isso, todas as nossas calculadoras são 100% gratuitas e não exigem cadastro.
          </p>

          <div className="bg-light-bg p-6 rounded-lg my-8">
            <h2 className="text-2xl font-heading font-bold text-dark-text mb-4">Nossas Ferramentas</h2>
            <ul className="space-y-2 text-body-text">
              <li>✓ <strong>Calculadora de Horas:</strong> Some e subtraia horas e minutos</li>
              <li>✓ <strong>Horas Trabalhadas:</strong> Calcule sua jornada semanal e mensal</li>
              <li>✓ <strong>Horas Extras:</strong> Calcule o adicional de 50% e 100%</li>
              <li>✓ <strong>Subtração de Horas:</strong> Diferença entre horários com suporte a turno noturno</li>
              <li>✓ <strong>Banco de Horas:</strong> Controle seu saldo conforme a CLT</li>
              <li>✓ <strong>Adicional Noturno:</strong> Calcule a hora noturna reduzida e o valor do adicional</li>
              <li>✓ <strong>Calculadora de Tempo e de Minutos:</strong> Some e converta horas, minutos e segundos</li>
              <li>✓ <strong>Contador de Horas:</strong> Cronômetro para contar horas de trabalho</li>
              <li>✓ <strong>Converter Horas em Dias:</strong> Descubra quantos dias são 72h, 48h, 36h e mais</li>
              <li>✓ <strong>Jornada de Trabalho e Valor da Hora:</strong> Horas por dia, divisor e valor da hora trabalhada</li>
              <li>✓ <strong>Guias CLT:</strong> Horas extraordinárias, limite de horas extras, banco de horas e horário noturno</li>
            </ul>
          </div>

          <p className="text-body-text text-lg leading-relaxed mb-6">
            Todos os nossos cálculos são baseados na legislação trabalhista brasileira vigente, incluindo a CLT e suas atualizações mais recentes.
          </p>

          <p className="text-body-text text-lg leading-relaxed">
            Se você tiver dúvidas ou sugestões, entre em contato conosco pela página de contato.
          </p>
        </article>
      </main>

      <Footer />
    </>
  );
};

export default SobrePage;
